
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import warehouseCity from '@/store/entities/warehouse-city';
    import warehouseInfo from '@/store/entities/warehouseInfo';
    import storeaddressInfo from '@/store/entities/back-storeaddress-list';
    import appconst from '@/lib/appconst';
    import Enums from '@/lib/enums'
    class AddStock {
        storeId: number;
        productSku: string;
        productType: number = 0;
        productName: string;
        purchaseCost: number;
        productImgGuid: string;
        productLink: string;
        productNums: number;
        remark: string;

    }
    @Component
    export default class CreatestockModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        stock: AddStock = new AddStock();
        selectDate: string = "";
        selectDates: string = "";
        warehouseCityId: number = 0;
        warehouseCityList: Array<warehouseCity> = [];
        warehouseInfoList: Array<warehouseInfo> = [];
        storeaddressList: Array<storeaddressInfo> = [];
        imgUrl: string = '';
        imgUploadUrl: string = '';
        cargoCategoryType = Enums.CargoCategoryType;
        productTypeList = Enums.ProductType;

        addLoding = false;
        amountTotal: string = '';;
        headers: any = {
            "Authorization": "Bearer " + window.abp.auth.getToken(),
            ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
            "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
        };

        handleSuccess(res, file) {
            if (res.success) {
                this.stock.productImgGuid = res.result;
                var data = { imageGuid: this.stock.productImgGuid, url: null };
                this.$store.commit('backlogistics/getImgUrl', data);
                this.imgUrl = data.url;
            }
        }


        handleError(res, file) {
            this.$Message.error('上传图片失败。' + res.message);
        }

        created() {
            this.imgUploadUrl = appconst.remoteServiceBaseUrl + "api/services/app/Logistics/UploadLogisticsImg";
            this.getData();
        }
        signFor() {
            this.save();
        }
        save() {
            (this.$refs.stockCreateForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    this.addLoding = true;
                    if (this.stock.productImgGuid == null) {
                        this.$Message.info("产品图片不能为空");
                        this.addLoding = false;
                        return;
                    }
                    await this.$store.dispatch({
                        type: 'frontstock/EditStock',
                        data: this.stock
                    }).finally(() => {
                        this.addLoding = false;
                    });
                    (this.$refs.stockCreateForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input', false);
                }
            })
        }
        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            if (this.storeaddressList.length > 0) {
                this.stock.storeId = this.storeaddressList[0].id;
            }
        }
        cancel() {
            (this.$refs.stockCreateForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
            }
        }
        stockRule = {
            productSku: [
                { required: true, message: '产品Sku不能为空', trigger: 'blur' }
            ],
            productName: [
                { required: true, message: '产品名称不能为空', trigger: 'blur' }
            ],
            productLink: [
                { required: true, message: '产品链接不能为空', trigger: 'blur' }
            ], 
            productNums: [
                { required: true,  message: '产品数量不能为空', trigger: 'blur' }
            ],
            purchaseCost: [
                { required: true,  message: '采购成本不能为空', trigger: 'blur' }
            ],
        };

    }
